import { takeEvery, put, call} from "redux-saga/effects"
import {GET_OFFER_LETTER_LIST} from './actionTypes'
import {getInterviewCandidateList} from "../../../../helpers/fakebackend_helper"
import { getOfferLetterListDataSuccess, getOfferLetterListDataFail} from './actions'

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* getOfferListDataHandler({payload: {json}}){
  let url = constClass.REST_API_OFFER_LETTER_LIST+`?page=${json.pageNumber}&pageSize=${json.pageSize}`
   let extentedUrl= ""
  if(json.sort !== undefined && json.Sort !== null){
       url = url+json.sort
  }
  if(json.keyword !== undefined && json.keyword  !== null && json.keyword  !== "" ){
    url = url+json.keyword
}
if(json.filter !== undefined && json.filter !== null && json.filter !== "" && json.filter.length > 0){
  extentedUrl = json.filter
  .map(eachObject => encodeURIComponent(eachObject.filterName) + "=" + encodeURIComponent(eachObject.value))
  .join("&");

// Now extendedUrl contains the constructed URL string
}
  try {
    if(extentedUrl !== ""){
     url =  url+"&"+extentedUrl
    }
    let response = yield call(getInterviewCandidateList, url);
    yield put(getOfferLetterListDataSuccess(response))
  }

  catch (error) {
    yield put(getOfferLetterListDataFail(error))
  }
}







function* OfferLetterListSaga() {
  yield takeEvery( GET_OFFER_LETTER_LIST, getOfferListDataHandler)
}
export default OfferLetterListSaga

